import React, { useState, useEffect } from 'react'
import { Modal, Button, Row, Col } from 'antd'
import { useHistory } from 'react-router-dom'
import * as com from '../../Common'
import { checkAccess } from "../../Auth"
import { UR_Owner } from '../../State'
import UpgradeToBusinessModal from '../../Management/UpgradeToBusinessModal'
import './PaywallModal.css'

export default function PaywallModal(props) {
    const {
        open, onCancel
    } = props
    const history = useHistory()
    const [currentPlan, setCurrentPlan] = useState('starter')
    const [isUpgradeModalOpen, setIsUpgradeModalOpen] = useState(false)

    // 获取当前用户的订阅信息
    useEffect(() => {
        const getCurrentSubscription = async () => {
            try {
                const token = sessionStorage.getItem("ZeitroA")
                if (token) {
                    const response = await fetch('/los/getcurrentsubscription', {
                        method: 'GET',
                        headers: {
                            Authorization: "Bearer " + token,
                            Cache: "no-cache"
                        }
                    })
                    
                    if (response.ok) {
                        const subscriptionData = await response.json()
                        setCurrentPlan(subscriptionData.plan || 'free')
                    }
                }
            } catch (error) {
                console.error("Error fetching subscription:", error)
                setCurrentPlan('free')
            }
        }

        if (open) {
            getCurrentSubscription()
        }
    }, [open])

    const modalCancel = () => {
        onCancel()
    }

    const handleCloseUpgradeModal = () => {
        setIsUpgradeModalOpen(false)
    }

    const handleUpgrade = () => {
        setIsUpgradeModalOpen(false)
        // 跳转到定价页面
        history.push('/app/management?select=Pricing')
    }

    // 如果当前 plan 是 starter，显示升级弹窗
    if (currentPlan === 'starter') {
        return (
            <UpgradeToBusinessModal
                isOpen={open}
                onClose={modalCancel}
                onUpgrade={handleUpgrade}
                onViewPlanDetail={() => {}}
                upgradeTo="individual"
            />
        )
    }

    // 否则显示原有的 PaywallModal 内容
    const serviceList = [
        {
            key: '1',
            text: 'Unlimited 1003 PDF & FNM 3.4 exports'
        },
        {
            key: '2',
            text: 'Unlimited Strata AI'
        },
        {
            key: '3',
            text: 'Call reports'
        },
        {
            key: '3',
            text: 'Customizable personal website and more...'
        }
    ]
    return (
        <>
            <Modal
                className="paywall-modal"
                styles={{ mask: { backgroundColor: 'rgba(0, 0, 0, 0.80)' } }}
                maskClosable={true}
                width={566}
                open={open}
                centered={true}
                title=""
                onCancel={modalCancel}
                footer={null}
            >
                <div className='paywall-title'>Upgrade to Business</div>
                <div className='paywall-description'>You’ve hit the limit for free chats. You can elevate your potential to new heights with our Business plan.</div>
                <div className='paywall-price'><span className='amount'>$35</span><span className='unit'>/mo per company</span></div>
                <div className='paywall-divider'></div>
                <div className='paywall-service-list'>
                    {
                        serviceList.map(item => {
                            return (
                                <div key={item.key} className='paywall-service-item'><img src='/images/paywall-check.svg' /><div className='paywall-service-item-text'>{item.text}</div></div>
                            )
                        })
                    }
                </div>
                {
                    checkAccess([UR_Owner]) ? (
                        <div className='paywall-btn'>
                            <Row gutter={[12, 12]} style={{width: '100%'}}>
                                <Col xs={24} sm={12}>
                                    <Button className="paywall-text-btn" type='link' onClick={() => history.push('/app/management?select=Pricing')} block>View plan details</Button>
                                </Col>
                                <Col xs={24} sm={12}>
                                    <Button className="paywall-btn-primary" type="primary" onClick={() => history.push('/app/management?select=Pricing')} block>Get started</Button>
                                </Col>
                            </Row>
                        </div>
                    ) : (
                        <div style={{textAlign: 'center'}} className='paywall-description'>please contact your account admin to upgrade.</div>
                    )
                }
                {/* <Divider
                    style={{
                        borderColor: '#D9D9D9'
                    }}
                    >
                    <span style={{ color: '#6E6E70', fontWeight: 400, fontSize: 14 }}>or</span>
                </Divider>
                <div className='paywall-recommend-card'>
                    <div className='paywall-recommend-card-title'>
                        <div className='paywall-recommend-card-title-text'><img src='/images/paywall-recommend.svg' /><span>Refer your friend</span></div>
                        <img style={{width: 20, height: 20}} src='/images/paywall-recommend-link.svg' />
                    </div>
                    <div className='paywall-recommend-card-description'>Earn free Originator features for you and your friend.</div>
                </div> */}
            </Modal>
        </>
    )
}